import "./scss/app-main.scss";
import "./js/main.js";
import "./js/lib.js";

import "./html/index.html";
import "./html/iframe2.html";
import "./html/iframe3.html";
import "./html/iframe4.html";
import "./html/iframereward.html";
